/**
 * Возраст порога — сколько дней назад его выставили.
 *
 * ЗАЧЕМ ОТДЕЛЬНЫЙ ФАЙЛ. Порог без даты — порог неизвестной давности, а от него
 * считаются все зоны: у Димы FTP и CSS приехали из intervals.icu 2026-06-07 и к
 * августу устарели на два месяца, но «Форма» показывала только «290 Вт», как
 * будто это измерено сегодня. Дата всё это время лежала в `metric_sources`
 * (ab05) и никем не читалась.
 *
 * Функция живёт в `lib`, а не рядом с запросом в `zonesApi`: экранные тесты
 * мокают модуль запросов целиком, и чистая функция внутри него исчезала вместе
 * с ним. Логика, которую хочется проверять на входах, не должна зависеть от
 * того, замокан ли сетевой слой.
 */

/** Происхождение метрики: `{поле: {source, set_at}}` (ab05). */
export type MetricSources = Record<string, { source?: string; set_at?: string }> | null;

/** Сколько дней назад выставлено значение поля, или null — даты нет. */
export function metricAgeDays(
  sources: MetricSources,
  field: string,
  now: Date = new Date(),
): number | null {
  const at = sources?.[field]?.set_at;
  if (!at) return null;
  const then = new Date(at).getTime();
  if (Number.isNaN(then)) return null;
  return Math.max(0, Math.floor((now.getTime() - then) / 86_400_000));
}
